module.exports = __webpack_public_path__ + "static/media/about-troubleshooters.61d55f67.svg";